<script setup lang="ts">
interface IGenre {
  slug: string;
  name: string;
}

interface IProps {
  tags: IGenre[],
  count?: number
}

const props = withDefaults(defineProps<IProps>(), {
  count: 0
});

const showLess = ref(true);
const hasMore = (props.tags && props.count && props.tags.length > props.count ? props.tags.length - props.count : 0);

const filteredTags = computed(() => hasMore && showLess.value ? props.tags.slice(0, props.count) : props.tags);

const toggleText = () => showLess.value = !showLess.value;
</script>

<template>
  <div v-if="filteredTags && filteredTags.length > 0" class="flex flex-wrap gap-2 items-center">
    <nuxt-link
        v-for="(tag) in filteredTags"
        :to="`/stories/${tag.slug}-novels`"
    >
      <tag>{{ tag.name }}</tag>
    </nuxt-link>
    <button v-if="hasMore" @click.prevent="toggleText" aria-label="More" class="text-violet-800 dark:text-primary">
      {{ showLess ? `+${hasMore} More` : '' }}
    </button>
  </div>
</template>

<style scoped>

</style>